import { render, staticRenderFns } from "./School.vue?vue&type=template&id=493d1c6d&scoped=true"
import script from "./School.ts?vue&type=script&lang=ts&external"
export * from "./School.ts?vue&type=script&lang=ts&external"
import style0 from "./school.scss?vue&type=style&index=0&id=493d1c6d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d1c6d",
  null
  
)

export default component.exports